import React from "react";

function Bg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="134"
      height="119"
      fill="none"
      viewBox="0 0 134 119"
    >
      <path
        fill="#060606"
        stroke="#80FF00"
        d="M133.5 20.988L114.065.5H.5v96.995L22.32 118.5H133.5V20.988z"
      ></path>
    </svg>
  );
}

export default Bg;
